import React from "react";
import {Grid, Typography} from "@mui/material";
import Select, {components} from "react-select";
import {ReactComponent as DropdownIcon} from "../../assets/flyerDetailsPopupAssets/dropdown.svg";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    labelCaption: (props: any) => ({
        '&.MuiTypography-root': {
            fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
            fontWeight: props.isBold ? `bold` : `normal`,
            fontFamily: props.defaultFontForLabel ? `roboto` : `revert`,
            marginRight: `12px`
        }
    })
}))


const DropdownIndicator = (props: any) => {
    return (
        <components.DropdownIndicator {...props}>
            <DropdownIcon/>
        </components.DropdownIndicator>
    );
};

interface Props {
    labelGridSizeNumber?: number;
    selectGridSizeNumber?: number;
    valueForSelect?: {
        value?: string | null;
        label?: string | null;
        id?: number | null;
    };
    onChangeSelect?: (item: any) => void;
    selectArray?: any[];
    labelCaption?: string | null;
    labelAlign?: `start` | `end` | `center`;
    fontSize?: string;
    isBold?: boolean;
    isRequired?: boolean;
    readonly?: boolean;
    defaultFontForLabel?: boolean;
    withDisabledSomeOptions?: boolean;
    disabledOptions?: string[];
}

export const SelectWithLabel: React.FC<Props> = ({
                                                     labelGridSizeNumber,
                                                     selectGridSizeNumber,
                                                     valueForSelect,
                                                     onChangeSelect,
                                                     selectArray,
                                                     labelCaption,
                                                     labelAlign,
                                                     fontSize,
                                                     isBold,
                                                     isRequired,
                                                     readonly,
                                                     defaultFontForLabel,
                                                     withDisabledSomeOptions = false,
                                                     disabledOptions = []
                                                 }) => {

    const customStylesForSelect = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            height: "34px",
            border: "1px solid #888888",
            borderLeft: isRequired ? `4px solid #E5870E` : `1px solid #888888`,
            borderRadius: isRequired ? `0 5px 5px 0` : `5px`,
            fontWeight: "normal",
            textAlign: "start",
            lineHeight: "1",
            minHeight: `auto`,
            cursor: "pointer",
            ":hover": {
                border: "1px solid #888888",
                borderLeft: isRequired ? `4px solid #E5870E` : `1px solid #888888`,
            },
        }),

        singleValue: (base: any) => ({
            ...base,
            // fontSize: `16px`,
            lineHeight: `20px`
            // height: "16px",
        }),
        valueContainer: (base: any) => ({
            ...base,
            height: "34px",
            padding: "0px 5px",
            fontSize: "14px",
        }),
        input: (base: any) => ({
            ...base,
            height: "34px",
        }),
        menuList: (base: any) => ({
            ...base,
            fontWeight: "normal",
            padding: "2px 0"

        }),
        menu: (base: any) => ({
            ...base,
            zIndex: `2`,
            margin: "4px 0"
        })
    };

    const properties = {
        fontSize: fontSize ? fontSize : `14`,
        isBold: isBold,
        defaultFontForLabel: defaultFontForLabel
    }
    const classes = useStyles(properties);
    return (
        <>
            <Grid item {...(labelGridSizeNumber ? {xs: labelGridSizeNumber} : {xs: true})}>
                <Typography className={classes.labelCaption} textTransform={`capitalize`}
                            textAlign={labelAlign ? labelAlign : 'start'}>
                    {labelCaption}
                </Typography>
            </Grid>
            <Grid item {...(selectGridSizeNumber ? {xs: selectGridSizeNumber} : {xs: true})}>
                {
                    readonly ?
                        <Typography fontSize={fontSize ? `${fontSize}px` : `14px`} lineHeight={`35px`}
                                    fontWeight={`400`} noWrap>
                            {valueForSelect?.label}
                        </Typography> :
                        <Select
                            styles={customStylesForSelect}
                            classNamePrefix="languagesSelect"
                            className={`select`}
                            value={valueForSelect}
                            isOptionDisabled={(option) => {
                                if (withDisabledSomeOptions) {
                                    return disabledOptions.some(disabledOption => disabledOption === option.value);
                                }
                                return false;
                            }}
                            onChange={onChangeSelect}
                            getOptionValue={(option) => option.value!}
                            getOptionLabel={(option) => option.label!}
                            options={selectArray}
                            isSearchable={false}
                            components={{
                                DropdownIndicator,
                            }}
                        />
                }
            </Grid>
        </>
    )
}